export const skillIdsMatch = (leftSkillId, rightSkillId) => String(leftSkillId) === String(rightSkillId);

export const getFirstIncompleteGame = (games = []) =>
  games.find(({ levelsMastered, levels }) => levelsMastered.length < levels.length);

export const getDefaultSkillId = (games = []) => {
  const firstIncomplete = getFirstIncompleteGame(games);
  return firstIncomplete ? firstIncomplete.skillId : 0;
};

export const isValidGameSelection = (games = [], selectedSkillId) =>
  games.some(({ skillId }) => skillIdsMatch(skillId, selectedSkillId));

/**
 * Resolves the game to launch, falling back to the first incomplete game when the
 * current selection is stale (e.g. after adaptivity replaces workshop placeholders).
 */
export const resolveSelectedGame = (games = [], selectedSkillId) => {
  const selectedGame = games.find(({ skillId }) => skillIdsMatch(skillId, selectedSkillId));
  if (!selectedGame) {
    return getFirstIncompleteGame(games);
  }
  return selectedGame;
};
